import _ from 'lodash';
import update from 'immutability-helper';

const PLUMBERS_MATCH = 'plumbers/PLUMBERS_MATCH'

const SET_LATLNG = 'plumbers/SET_LATLNG'

export const GET_PLUMBER_DYNAMIC_REQUEST = 'plumbers/GET_PLUMBER_DYNAMIC_REQUEST'
export const GET_PLUMBER_DYNAMIC = 'plumbers/GET_PLUMBER_DYNAMIC'
export const GET_PLUMBER_DYNAMIC_ERROR = 'plumbers/GET_PLUMBER_DYNAMIC_ERROR'

type RequestStatus = ('pending' | 'noMatches' | 'matchesFound');





type InitialState = {
  plumbers: {},
  status: RequestStatus,
  lat: ?string,
  lng: ?string,
  url: ?string,
  plumberCount: ?string
};

const initialState = {
  plumbers: {},
  status: 'pending',
  lat: '',
  lng: '',
  url:'',
  plumberCount: ''
}


export function dispatchPlumbersMatch(status: RequestStatus) {
    return {
        type: PLUMBERS_MATCH,
        payload: status
    }
}


export function setLatLng (lat, lng) {
  return {
    type: SET_LATLNG,
    payload: {
      lat, lng
    }
  }
}

export function getPlumberDynamic() {

  return {
    type: GET_PLUMBER_DYNAMIC_REQUEST,
    payload: {}
  }
}


export default function PlumbersStateReducer (state: InitialState = initialState, action = {}) {
  let data



  switch (action.type) {

    case SET_LATLNG:
    data = action.payload

      return update(state, {
        $set: {
          lat: data.lat,
          lng: data.lng,
        }
      });



      case PLUMBERS_MATCH:
        return update (state, {
          $merge: {
            status: action.payload
          }
        });



   

      case GET_PLUMBER_DYNAMIC:
        return update (state, {
          $merge: {
            plumbers: action.payload,
            plumberCount: action.payload.length
          }
        });



    default:
      return state
  }
}





// WEBPACK FOOTER //
// ./src/modules/plumbers.js